import masterpieceArtwork from "./stage7/jigsaw.jpg";
import masterpieceFrame from "./stage7/frame.png";

/** Points written to DB `stage7` on successful restore. */
export const MASTERPIECE_POINTS = 100;

/** Puzzle 2 hotspot unlocked after Masterpiece success. */
export const MASTERPIECE_UNLOCKS = "restore_journal";

/**
 * Artwork for the jigsaw — swap this import (or override `src`) to change the painting.
 * Keep aspect roughly landscape for best 4×4 / 5×5 cropping.
 */
export const MASTERPIECE_ARTWORK = {
  id: "bharat_mata",
  title: "Bharat Mata",
  artist: "Abanindranath Tagore",
  src: masterpieceArtwork,
  frame: masterpieceFrame,
  /** Interlocking jigsaw piece count. Use 16 (4×4) or 25 (5×5). */
  pieceCount: 16,
};

export const MASTERPIECE_CLUE =
  "Knowledge reveals what the eyes cannot.";

export const MASTERPIECE_SUCCESS_COPY = {
  title: "Masterpiece restored!",
  body: "Looks like someone left a clue inside the frame...",
  clueLabel: "Bookmark clue",
};

/** @param {number} pieceCount */
export function gridDimsFromPieceCount(pieceCount = 16) {
  const side = Math.sqrt(pieceCount);
  if (!Number.isInteger(side) || side < 2) {
    throw new Error(
      `pieceCount must be a perfect square >= 4 (got ${pieceCount})`
    );
  }
  return { cols: side, rows: side };
}

/**
 * background-position % for a tile at (col, row) in an N×N CSS sprite grid.
 * @param {number} col
 * @param {number} row
 * @param {number} cols
 * @param {number} rows
 */
export function tileBackgroundPosition(col, row, cols, rows) {
  const x = cols <= 1 ? 0 : (col / (cols - 1)) * 100;
  const y = rows <= 1 ? 0 : (row / (rows - 1)) * 100;
  return { x, y };
}

/** Fisher–Yates derangement: no piece starts in its correct slot. */
export function derangeTiles(tiles) {
  const n = tiles.length;
  const order = Array.from({ length: n }, (_, i) => i);

  for (let i = n - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }

  for (let i = 0; i < n; i += 1) {
    if (order[i] === i) {
      const swapWith = i === 0 ? 1 : i - 1;
      [order[i], order[swapWith]] = [order[swapWith], order[i]];
    }
  }

  return order.map((srcIndex, slotIndex) => ({
    ...tiles[srcIndex],
    slotIndex,
    inPlace: false,
  }));
}

export function buildMasterpieceTiles(pieceCount = MASTERPIECE_ARTWORK.pieceCount) {
  const { cols, rows } = gridDimsFromPieceCount(pieceCount);
  const tiles = [];
  for (let i = 0; i < pieceCount; i += 1) {
    const row = Math.floor(i / cols);
    const col = i % cols;
    const { x, y } = tileBackgroundPosition(col, row, cols, rows);
    tiles.push({
      id: `tile-${i}`,
      originalIndex: i,
      row,
      col,
      bgX: x,
      bgY: y,
    });
  }
  return { cols, rows, tiles: derangeTiles(tiles) };
}
